import { render, staticRenderFns } from "./ArticoloCicloFasiNew.vue?vue&type=template&id=3b2e015a&"
import script from "./ArticoloCicloFasiNew.vue?vue&type=script&lang=js&"
export * from "./ArticoloCicloFasiNew.vue?vue&type=script&lang=js&"
import style0 from "./ArticoloCicloFasiNew.vue?vue&type=style&index=0&id=3b2e015a&prod&css=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports